import React, { createContext, useState, useContext, useEffect, ReactNode } from 'react';

// Define the shape of the context data
interface CompanyContextType {
  selectedCompanyId: string;
  setSelectedCompanyId: (id: string) => void;
}

// Create the context with a default value
const CompanyContext = createContext<CompanyContextType>({
  selectedCompanyId: "",
  setSelectedCompanyId: () => {},
});

// Create a provider component
interface CompanyProviderProps {
  children: ReactNode;
}

export const CompanyProvider: React.FC<CompanyProviderProps> = ({ children }) => {
  const [selectedCompanyId, setSelectedCompanyIdState] = useState<string>("");

  // Store the company ID as-is from the database (with COMPANY# prefix if present)
  // No localStorage - company selection is session-based only
  const setSelectedCompanyId = (id: string) => {
    setSelectedCompanyIdState(id);
  };

  return (
    <CompanyContext.Provider value={{ selectedCompanyId, setSelectedCompanyId }}>
      {children}
    </CompanyContext.Provider>
  );
};

// Create a custom hook for easy consumption
export const useCompany = () => {
  const context = useContext(CompanyContext);
  if (context === undefined) {
    throw new Error('useCompany must be used within a CompanyProvider');
  }
  return context;
};
